module.exports = __webpack_public_path__ + "static/media/Notification-ReadyToShip-Email-Preview.b44dd95a.png";